import { fetchRegions } from '../api'
import {
  HOMEPAGE_REGIONS_REQUEST,
  HOMEPAGE_REGIONS_SUCCESS,
  HOMEPAGE_REGIONS_FAILURE
} from '../constants'

export const getRegions = () => async (dispatch, getState) => {
  try {
    dispatch({ type: HOMEPAGE_REGIONS_REQUEST })

    const { data } = await fetchRegions()

    dispatch({
      type: HOMEPAGE_REGIONS_SUCCESS,
      payload: data.regions
    })
  } catch {
    dispatch({
      type: HOMEPAGE_REGIONS_FAILURE,
      payload: 'error'
    })
  }
}
